import axios from "axios";
import { GenericResponse } from "./interceptor";

class ContactService {
    sendContactRequest(data:any={}):Promise<GenericResponse> {
        return axios.post(`/v1/default/contact`, data);
    }
}

export default new ContactService();